import EditModeButtons from "../molecules/EditModeButtons";
import TitleEditField from "../atom/TitleEditField";
import DescEditField from "../atom/DescEditField";


const HistoryDetailEdit = ({ item, toggleEditModeHandler, subModalMount, closeSubModal, closeModal, formData, handleInputChange, handleUpdateHistory }) => {

  return (
    <>
      <div className={"detail-design-history-body"}>
        <div className={"detail-design-history-inner edit"}>
          <div className={"detail-design-history-images"}>
            <div className={"screenshot"}>
              <img src={item.extImage} alt={"Vehicle Exterior Image"}/>
            </div>
            <div className={"screenshot"}>
              <img src={item.intImage} alt={"Vehicle Interior Image"}/>
            </div>
          </div>
          <div className={"detail-design-history-contents"}>
            <TitleEditField formData={formData} handleInputChange={handleInputChange}/>
            <DescEditField formData={formData} handleInputChange={handleInputChange}/>
          </div>
        </div>
      </div>
      <div className={"detail-design-history-footer"}>
        <div className={"detail-design-history-inner"}>
          <div className={"detail-design-history-footer-buttons"}>
            <EditModeButtons toggleEditModeHandler={toggleEditModeHandler}
                             subModalMount={subModalMount}
                             closeModal={closeModal}
                             closeSubModal={closeSubModal}
                             handleUpdateHistory={handleUpdateHistory}
                             formData={formData}
            />
          </div>
        </div>
      </div>
    </>
  )

}

export default HistoryDetailEdit;
